/* eslint-disable import/no-extraneous-dependencies */
import Cookies from "js-cookie";
import _isString from "lodash/isString";

const webStorage = {
  set(key, rawValue, option) {
    const value = _isString(rawValue) ? rawValue : JSON.stringify(rawValue);

    Cookies.set(key, value, option);
  },
  get(key) {
    const value = Cookies.get(key);

    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  },

  remove(key) {
    Cookies.remove(key);
  },
  removeAll() {
    Object.keys(Cookies.get())?.forEach(cookieName => {
      Cookies.remove(cookieName);
    });
    localStorage.clear();
  },
};

export default webStorage;
